import * as exPopovers from './utils';

// ----------------------------------------------------------------------------

declare global {
    interface HTMLElement {
        showPopovers(config?: Record<string, any>): void;
        hidePopovers(config?: Record<string, any>): void;
        togglePopovers(config?: Record<string, any>): void;
    }
}

// ----------------------------------------------------------------------------

HTMLElement.prototype.showPopovers = function (config: Record<string, any> = {}): void {
    exPopovers.show(this, config);
};

HTMLElement.prototype.hidePopovers = function (config: Record<string, any> = {}): void {
    exPopovers.hide(this, config);
};

HTMLElement.prototype.togglePopovers = function (config: Record<string, any> = {}): void {
    exPopovers.toggle(this, config);
};
